/**Dependencies */
import React from 'react';

/**Styles */
import '../styles/components/loader.scss';

/**Images */
import gif from '../images/loader-international.gif';


export const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader d-flex justify-content-center">
        <img src={gif} alt="Cargando..." />
      </div>
    </div>
  )
}
